import React, { useState } from "react";
import { Button, TextField } from "components";
import "./index.css";

const PasswordForm = ({ handleFieldChange, toggleSnackbarAndSetText, form }) => {
  const fields = form.fields || {};
  const submit = form.submit;
  const { newpassword, confirmnewpassword } = fields;

  const [showPassword, setShowPassword] = useState({
    existingPassword: false,
    newpassword: false,
    confirmnewpassword: false,
  });

  const toggleVisibility = (key) => {
    setShowPassword((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  const renderPasswordField = (key, fieldProps, className) => (
    <div className="password-field-wrapper" style={{ position: "relative" }}>
      <TextField
        className={className}
        onChange={(e, value) => handleFieldChange(key, value)}
        {...fieldProps}
        onKeyDown={(e) => {
          if (/\s/.test(e.key)) {
            e.preventDefault();
          }
        }}
        type={showPassword[key] ? "text" : "password"}
      />
      <span
        className="password-eye-icon"
        onClick={() => toggleVisibility(key)}
        style={{
          position: "absolute",
          right: "12px",
          top: "50%",
          transform: "translateY(-50%)",
          cursor: "pointer",
        }}
      >
        {showPassword[key] ? (
          // eye-open icon
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
            <circle cx="12" cy="12" r="3" />
          </svg>
        ) : (
          // eye-closed icon
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
            <path d="M17.94 17.94A10.94 10.94 0 0 1 12 20c-7 0-11-8-11-8a18.5 18.5 0 0 1 5.06-5.94M9.9 4.24A9.12 9.12 0 0 1 12 4c7 0 11 8 11 8a18.5 18.5 0 0 1-2.16 3.19M14.12 14.12a3 3 0 1 1-4.24-4.24" />
            <line x1="1" y1="1" x2="23" y2="23" />
          </svg>
        )}
      </span>
    </div>
  );

  return (
    <div>
      <div className="employee-change-password">
        {renderPasswordField("existingPassword", fields.existingPassword, "emp-change-passwd-field")}
        {renderPasswordField("newpassword", fields.newpassword, "emp-change-passwd-field")}
        {renderPasswordField("confirmnewpassword", fields.confirmnewpassword, "emp-change-passwd-field")}

        <div className="password-requirements">
          <div className="requirements-title">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7 10V7C7 4.239 9.239 2 12 2C14.761 2 17 4.239 17 7V10" stroke="#1976D2" strokeWidth="2" strokeLinecap="round" />
              <rect x="5" y="10" width="14" height="11" rx="2" stroke="#1976D2" strokeWidth="2" />
              <circle cx="12" cy="15.5" r="1" fill="#1976D2" />
            </svg>
            {/* <LockOutlinedIcon className="lock-icon" /> */}
            <span>Password must contain:</span>
          </div>

          <div className="requirements-grid">
            <div className="requirement-item">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#16A34A" />
                <path d="M7.5 12.5L10.5 15.5L16.5 9" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              {/* <CheckCircleIcon className="check-icon" /> */}
              <span>At least 1 uppercase letter (A-Z)</span>
            </div>

            <div className="requirement-item">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#16A34A" />
                <path d="M7.5 12.5L10.5 15.5L16.5 9" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <span>At least 1 number (0-9)</span>
            </div>

            <div className="requirement-item">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#16A34A" />
                <path d="M7.5 12.5L10.5 15.5L16.5 9" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <span>At least 1 lowercase letter (a-z)</span>
            </div>

            <div className="requirement-item">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="10" fill="#16A34A" />
                <path d="M7.5 12.5L10.5 15.5L16.5 9" stroke="#FFFFFF" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
              </svg>
              <span>At least 1 special character (!@#$%^&*_-)</span>
            </div>
          </div>

          <div className="password-example">
            <strong>Example:</strong>
            <span>Abc@1234</span>
          </div>
        </div>

        <div className="changepassword-button">
          <Button
            {...submit}
            className="responsive-action-button"
            fullWidth={true}
            primary={true}
            onClick={(e) => {
              if (fields.existingPassword.value === newpassword.value) {
                e.preventDefault();
                toggleSnackbarAndSetText(
                  true,
                  {
                    labelName: "New password must be different from existing password",
                    labelKey: "New password must be different from existing password",
                  },
                  "error"
                );
                return;
              }
              if (newpassword.value !== confirmnewpassword.value) {
                e.preventDefault();
                toggleSnackbarAndSetText(
                  true,
                  {
                    labelName: "Password do not match",
                    labelKey: "ERR_PASSWORD_DO_NOT_MATCH",
                  },
                  "error"
                );
              }
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default PasswordForm;



// WEBPACK FOOTER //
// src/modules/employee/User/ChangePassword/components/PasswordForm/index.js